import React, { useState, createContext, useContext } from 'react';

import Spinner from "../../Components/Common/UI/Spinner/Spinner";

export const SpinnerContext = createContext();

export const SpinnerContextProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);


  const setSpinner = data => {
    setIsLoading(data);
  };

  // const memoedValue = useMemo(() => ({
  //   setSpinner
  // }),
  //   []
  // );
  return (
    <SpinnerContext.Provider value={{ setSpinner }}>

      {children}
      {isLoading && <Spinner />}

    </SpinnerContext.Provider>
  );
};
export function useSpinner() {
  return useContext(SpinnerContext);
}
